$(function(){

    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const common = require('./_data/common');
    const contact =  require('./_data/contact');
    const links =  require('./_data/links');
    const envSettings = myProject[myProject.environment];
    
    let prefix;
    switch (language) {
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }
    // defaults
    $.ajaxSetup({
        headers: {
            "X-TimeZoneName": timeZoneName,
            "X-Language": language,
            "X-Prefix": prefix
        },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    let locale = $("#locale").val();
    const Uris = {
        jsonCommissionsSendEmail : envSettings.server + "/json/commissions/sendemail",
        jobApplicationAdd : envSettings.server + "/json/jobapplications/applicant/add",
        nextPageUri: links[locale].thankYouPage,
    }

    $("#commissionsForm").on("submit", function(event)
    {
        event.preventDefault();
        const email = $("#commissionsEmail").val();
        const emailConfirm = $("#commissionsEmailConfirm").val();
        
        if (email !== emailConfirm) {
            $("#alert-space").html(
                '<div class="alert alert-warning alert-dismissible fade show" role="alert">' + common[language].alertEmailConfirmFail + '</div>'  
            );
            return;
        }
        if( $('#commissionsForm')[0].checkValidity()){
            setSendBtnDisabled();
            // TODO: switch case
            let uriPath;
            switch (locale) {
                case "en":
                    uriPath = "en/become-an-interpreter";
                    break;
                case "fi":
                    uriPath = "fi/tulkiksi/palkkiot-ja-tyonkuvaus";
                    break;
                case "is":
                    uriPath = "is/verda-tulk";
                    break;
                default:
                    uriPath = "fi/tulkiksi/palkkiot-ja-tyonkuvaus";  // Fallback to Finnish if the locale is unrecognized
            }
            // const uriPath = locale == "en" 
            // ? "en/become-an-interpreter" 
            // : "fi/tulkiksi/palkkiot-ja-tyonkuvaus" ;
            const data = {
                firstName: $("#commissionsFirstName").val(),
                lastName: $("#commissionsLastName").val(),
                email: $("#commissionsEmail").val(),
                phoneNumber: $("#commissionsPhoneNumber").val(),
                languageCode: locale,
                userLanguagesText: $("#commissionsSkills").val(),
                uri: uriPath,
            }
            $.ajax({
                url: Uris.jobApplicationAdd,
                method:"POST",
                data: JSON.stringify(data)
            })                
            .done(function() {
                
                window.location.href = Uris.nextPageUri;
                setSendBtnActive();
            })
            .fail(function(err){
               // console.log(err);
               setSendBtnActive();
               showAlert();
            });
        }
    });

    function setSendBtnDisabled(){
        $("#commissionsSendBtn").prop("disabled",true);
        $("#commissionsSendBtn").html(
         '<span class="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>' + common[language].loading
       );
    }

    function setSendBtnActive(){
        $("#commissionsSendBtn").prop("disabled",false);
        $("#commissionsSendBtn").html(common[language].send);
    }

    function showAlert(){
        let number = $("#phoneSales").val();
        let numberCaption = $("#phoneSalesCaption").val();
        $("#alert-space").html(
          '<div class="alert alert-warning alert-dismissible fade show" role="alert">' + common[language].alertSubmitFailed + ' <a href="mailto:'+contact[language].applyEmail+'">'+contact[language].applyEmail+'</a>.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>'
        );
    }
})